import { UTable } from '@components/common/UTable/UTable';

import { useGetDictionariesQuery } from '@/api/dictionaries/api';
import {
  columns,
  columnsNumber,
} from '@/pages/Vaccination/components/task/columns.config';

export const ProtocolEventsHeader = () => {
  const { data: dictionaries } = useGetDictionariesQuery();

  const EmptyBody = () => null;

  const components = {
    body: {
      wrapper: EmptyBody,
      row: EmptyBody,
    },
  };

  return (
    <>
      <UTable
        className="order-table"
        size={'small'}
        data={[]}
        columns={columns}
        components={components}
      />
      <UTable
        className="order-table order-column-number"
        size={'small'}
        data={[]}
        columns={columnsNumber(dictionaries?.dictMap)}
        components={components}
      />
    </>
  );
};
